<template>
  <svg
    class="custom-icon"
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
  >
    <path
      d="M7 10.1111C8.71822 10.1111 10.1111 8.71822 10.1111 7C10.1111 5.28178 8.71822 3.88889 7 3.88889C5.28178 3.88889 3.88889 5.28178 3.88889 7C3.88889 8.71822 5.28178 10.1111 7 10.1111Z"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M14 7C14 10.866 10.866 14 7 14C3.13401 14 0 10.866 0 7C0 3.13401 3.13401 0 7 0C10.866 0 14 3.13401 14 7ZM12.0556 7C12.0556 9.79211 9.79211 12.0556 7 12.0556C4.20789 12.0556 1.94444 9.79211 1.94444 7C1.94444 4.20789 4.20789 1.94444 7 1.94444C9.79211 1.94444 12.0556 4.20789 12.0556 7Z"
    />
  </svg>
</template>
